import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";
import TenderTable from "./TenderTable";
import axios from "axios";
import VQTable from "./VQTable";
import BidsTable from "./TechnicalHead/BidsTable";
import QueryTable from "./QueryTable";
import ItemCount from "../../utils/ItemCount";

const TechnicalHeadPending = () => {
  const [tenders, setTenders] = useState();
  const [vq, setVq] = useState();
  const [query, setQuery] = useState();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [activeTab, setActiveTab] = useState("QUERY");
  const [isLoading, setIsLoading] = useState(true);
  const [isVQLoading, setIsVQLoading] = useState(true);
  const [isQueryLoading, setIsQueryLoading] = useState(true);
  const [pendingActions, setPendingActions] = useState(false);
  const [queryCount, setQueryCount] = useState(0);
  const [vendorCount, setVendorCount] = useState(0);
  const [bidCount, setBidCount] = useState(0);

  useEffect(() => {
    const getQueryCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/query/item?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setQueryCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getQueryCount();
    const getVendorCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-tender/org?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setVendorCount(res.data.length);
      } catch (error) {
        console.log(error);
      }
    };
    getVendorCount();
    const getBidCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid/item?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setBidCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getBidCount();
  }, []);

  useEffect(() => {
    if (activeTab === "VENDOR") {
      const getTenders = async () => {
        setTenders();
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/tender?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setTenders(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getTenders();
    } else if (activeTab === "BIDS") {
      const getBidsByTender = async () => {
        localStorage.removeItem("tab");
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/bid?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setTenders(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getBidsByTender();
    }
  }, [activeTab]);

  const getVendorTenders = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-tender/org?username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setVq(res.data);
      setIsVQLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getQuery = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/query/get-tenders?username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setQuery(res.data);
      setIsQueryLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (activeTab === "VQ") {
      getVendorTenders();
    }
    if (activeTab === "QUERY") {
      getQuery();
    }
  }, [activeTab]);

  useEffect(() => {
    if (localStorage.getItem("pending")) {
      setActiveTab("VQ");
      setPendingActions(true);
      localStorage.removeItem("pending");
    }
  }, []);
  return (
    <Box sx={{ textAlign: "center" }}>
      <Typography variant="h5" textAlign={"start"} fontWeight={"bold"}>
        My Pending Actions
      </Typography>
      <Box className="dashboard-container" sx={{ height: 400, width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
            borderBottom: "1px solid #D1D1D1",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <Button
              className={`dashboard-btns ${
                activeTab === "QUERY" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("QUERY");
                setIsLoading(true);
                // setPendingActions(false);
                // setVq();
                // setIsVQLoading(true);
              }}
            >
              Query <ItemCount count={queryCount} />
            </Button>
            <Button
              className={`dashboard-btns ${activeTab === "VQ" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("VQ");
                setIsLoading(true);
              }}
            >
              Vendor Qualification <ItemCount count={vendorCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "BID" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("BID");
                setIsLoading(true);
              }}
            >
              Bids Qualification <ItemCount count={bidCount} />
            </Button>
          </Box>
        </Box>
        {activeTab === "VQ" ? (
          <VQTable
            vendors={vq}
            activeTab={activeTab}
            isLoading={isVQLoading}
            getVendorTenders={getVendorTenders}
          />
        ) : activeTab === "BID" ? (
            <BidsTable
              tenders={tenders}
              isLoading={isLoading}
              storedUser={storedUser}
            />
          ) : activeTab === "QUERY" ? (
          <QueryTable tenders={query} isLoading={isQueryLoading} />
        ) : null}
      </Box>
    </Box>
  );
};

export default TechnicalHeadPending;
